export default __webpack_public_path__ + "static/media/m.116e6534.svg";